<div class="grid m-0 p-0">

  <div class="col-12 m-0 p-0">
    <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
  </div>

  <ng-container card-body>
    <div *ngIf="(isLoading$ | async)" class="w-full flex align-items-center justify-content-center">
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>
  </ng-container>

  <div *ngIf="!(isLoading$ | async)" class="col-12 m-0 p-0 mt-4">

    <split-table card-body [dados]="(lista$ | async)!" theme="primary" [widthColumns]="[50, 15, 30, 2]">


      <ng-template #header>
        <div class="w-full text-left ml-6">Serviço</div>
      </ng-template>
      <ng-template #coluna let-item="dadosLinha">
        <div class="width-full text-left">
          <span class="orange-text ml-6">{{ item.service }}</span>
        </div>
      </ng-template>

      <ng-template #header>Tempo de Entrega</ng-template>
      <ng-template #coluna let-item="dadosLinha">
        {{item.delivery}}
      </ng-template>

      <ng-template #header>Profissional</ng-template>
      <ng-template #coluna let-item="dadosLinha">
        {{item.professional}}
      </ng-template>

      <ng-template #header></ng-template>
      <ng-template #coluna let-item="dadosLinha">

      </ng-template>


      <ng-template #header></ng-template>
      <ng-template #coluna let-item="dadosLinha">
        <div class="flex align-items-center justify-content-around mr-4">
          <p-button [rounded]="true" [text]="true" severity="secondary"
            (onClick)="$event.stopPropagation(); editCard(item)">
            <ng-template pTemplate="icon">
              <div class="flex">
                <split-icon name="edit" size="20"></split-icon>
              </div>
            </ng-template>
          </p-button>
          <p-button class="ml-2" [rounded]="true" [text]="true" severity="danger"
            (onClick)="$event.stopPropagation(); deleteCard(item.id)">
            <ng-template pTemplate="icon">
              <div class="flex">
                <split-icon name="trash" size="20"></split-icon>
              </div>
            </ng-template>
          </p-button>
        </div>
      </ng-template>
    </split-table>
  </div>
  <div *ngIf="!(isLoading$ | async)" class="col-12 m-0 p-0">
    <div class="col-12  m-0 p-0 mt-7 text-right">
      <p-button (onClick)="showForm()" class="ml-4" label="Adicionar entrega"></p-button>
    </div>
  </div>
</div>



<p-dialog [(visible)]="mostrarModalDeletar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
  [modal]="true">
  <div class="content">
    <img src="assets/lista-unidade/modal-deletar/deletar-unidade.svg" alt="imagem deletar unidade" />
    <span class="title">
      <p>Tem certeza que deseja deletar</p>
      <p>esse Serviço?</p>
    </span>
    <span class="message">
      <p>Ao confirmar você excluirá permanentemente</p>
      <p>a serviço selecionada</p>
    </span>
  </div>
  <ng-template pTemplate="footer">
    <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
    <button class="deletar" (click)="deleteCardDelete()">Deletar</button>
  </ng-template>
</p-dialog>